/**
 * Shared design tokens — Refinea Design System "Precision Minimalism".
 * Accent: #6c47ff · Background: #f5f6f7 · Foreground: #000000
 */
export const brand = {
  color: "#6c47ff",             // accent
  text: "rgba(0,0,0,0.75)",    // foreground — soft black (less eye strain)
  muted: "rgba(0,0,0,0.5)",    // black/50
  border: "rgba(0,0,0,0.06)",  // card border
  bg: "#ffffff",                // card / modal surface
  subtle: "#f5f6f7",            // page background (off-white warm)
  success: "#10b981",           // emerald-500
  danger: "#ef4444",            // red-500
  accentSoft: "rgba(108,71,255,0.08)",    // active bg / badge fill
  accentBorder: "rgba(108,71,255,0.15)",  // badge / active border
} as const;

export type Brand = typeof brand;
